const styles = {
  button: {
    pink: {
      backgroundColor: '#E6174F',
    },
    grey: {
      backgroundColor: '#476166',
      color: '#CED7D9',
    },
    green: {
      backgroundColor: '#17E685',
      color: '#476166',
    },
    green2: {
      backgroundColor: '#084D2C',
      color: '#B6F2D6',
    },
    base: {
      flexBasis: '25%',
      fontSize: '11px',
      fontWeight: 'bold',
      cursor: 'pointer',
      clear: 'both',
      color: 'white',
      textTransform: 'uppercase',
      backgroundColor: 'red',
      textAlign: 'center',
      padding: '0 20px',
      boxSizing: 'border-box',
      lineHeight: '40px',
    },
  },

  footer: {
    display: 'flex',
    backgroundColor: 'rgba(61, 74, 77,0.5)',
    bottom: '0',
    height: '40px',
    width: '100%',
    justifyContent: 'flex-end',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListFooter/ProjectListFooter.styles.js